const loginSchema = {
  feilds: [
    {
      id: 0,
      name: "login",
      text: "Login",
      visible: true,
      element: "label",
      className: [],
      required: false,
    },
    {
      id: 1,
      name: "userid",
      text: "User ID",
      visible: true,
      element: "input",
      required: true,
      input_type: "email",
      placeholder: "User ID",
      icon: "user",
      rules: [
        {
          test: (value) => {
            return value.length > 0;
          },
          message: "Please Enter Your Userid",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 2,
      name: "password",
      text: "Password",
      visible: true,
      icon: "key",
      element: "input",
      required: true,
      input_type: "password",
      placeholder: "Password",
      rules: [
        {
          test: (value) => {
            return value.length > 0;
          },
          message: "Please Enter Your Password",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 0,
      name: "button",
      text: "Sign In",
      visible: true,
      required: false,
      element: "button",
      input_type: "button",
      disable: false,
    },
  ],
};

const forgotSchema = {
  feilds: [
    {
      id: 0,
      name: "forgotpassword",
      title: "Forgot Password ?",
      visible: true,
      element: "label",
      className: [],
      required: false,
    },
    {
      id: 1,
      name: "user_name",
      title: "Username",
      visible: true,
      element: "input",
      required: true,
      input_type: "text",
      placeholder: "Enter",
      icon: "user",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Enter Username",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 0,
      name: "button",
      text: "Send OTP",
      visible: true,
      required: false,
      element: "button",
      input_type: "button",
      disable: false,
    },
  ],
};
const formotpData = {
  feilds: [
    {
      id: 0,
      name: "enterotp",
      title: "Enter Your OTP",
      visible: true,
      element: "label",
      className: [],
      required: false,
    },
    {
      id: 1,
      name: "otp",
      title: "Enter Your OTP",
      visible: true,
      element: "input",
      required: true,
      input_type: "text",
      placeholder: "Enter",
      icon: "user",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 4 && value.length < 6;
          },
          message: "Please Enter Valid OTP",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 0,
      name: "button",
      text: "submit",
      visible: true,
      required: false,
      element: "button",
      input_type: "button",
      disable: false,
    },
  ],
};
const resetpasswordSchema = {
  feilds: [
    {
      id: 0,
      name: "resetpassword",
      text: "Reset Password",
      visible: true,
      element: "label",
      className: [],
      required: false,
    },
    {
      id: 1,
      name: "password",
      title: "new password",
      visible: true,
      element: "input",
      required: true,
      input_type: "password",
      placeholder: "Enter",
      icon: "user",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 5;
          },
          message: "Password must contain atleast 6 characters ",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 2,
      name: "confirmpassword",
      title: "confirm New Password",
      visible: true,
      icon: "key",
      element: "input",
      required: true,
      input_type: "password",
      placeholder: "Enter",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 5;
          },
          message: "Please Enter Your confirm New Password",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 0,
      name: "button",
      text: "Submit",
      visible: true,
      required: false,
      element: "button",
      input_type: "button",
      disable: false,
    },
  ],
};

export { loginSchema, forgotSchema, resetpasswordSchema, formotpData };
